<template>
  <v-row justify="center">
    <iframe id="ytplayer" type="text/html" width="1008" height="567" :src="embedUrl" frameborder="0" />
  </v-row>
</template>

<script>
export default {
  props: {
    screen: {
      type: Object,
      required: true
    }
  },
  computed: {
    youtubeUrl() {
      return this.screen.url;
    },
    urlEnd() {
      if (!this.youtubeUrl.startsWith('https://youtu.be')) {
        const queryParams = new URLSearchParams(this.youtubeUrl.split('?')[1]);
        return `${queryParams.get('v')}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      } else {
        let urlEnd = this.youtubeUrl.split('.be/')[1];
        const splittedPath = urlEnd.split('?');
        urlEnd = splittedPath[0];
        const queryParams = new URLSearchParams(splittedPath[1]);
        return `${urlEnd}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      }
    },
    embedUrl() {
      return `https://www.youtube.com/embed/${this.urlEnd}`;
    }
  }
};
</script>
